import React from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'reactstrap';
import { MainHeadline } from '../components/Headline/MainHeadline';
import { SecondaryHeadline } from '../components/Headline/SecondaryHeadline';
import videoSources from '../videoSources';
import VideoItem from '../components/VideoFeed/VideoItem';
import ViewLayout from '../components/ViewLayout';
import { Offline, Online } from 'react-detect-offline';

const HeadlineWrapper = styled.div`
  text-align: center;
  color: #ffffff;
`;

const HomeView = () => (
  <ViewLayout>
    {/* <Online polling={{ enabled: true, interval: 500 }}> */}
    <Online>
      <Container>
        <HeadlineWrapper>
          <MainHeadline>
          Download and watch anytime anywhere!
          </MainHeadline>
          <SecondaryHeadline></SecondaryHeadline>
        </HeadlineWrapper>
        <Row>
          <Col>
            {videoSources.map((video, i) => <VideoItem {...video} key={i} />)}
          </Col>
        </Row>
      </Container>
    </Online>
    {/* <Offline polling={{ enabled: false, interval: 500 }}> */}
    <Offline>
      <Container>
        <MainHeadline>offline view </MainHeadline>
        <SecondaryHeadline>
          You can only watch your downloaded videos under{' '}
          <a className="button-link" href="/downloads">
            MY DOWNLOADS
          </a>.
        </SecondaryHeadline>
      </Container>
    </Offline>
  </ViewLayout>
);

export default HomeView;



// WEBPACK FOOTER //
// ./src/views/Home.jsx